import axios from 'axios';
import $i18n from '@/i18n';
const i18n: any = $i18n.global;

// timeout for AutoTopUp data = 60sec in ms
const SUBSCRIBER_DATA_TIMEOUT = 900000;
const RESPONSE_CODE_OK = 0;

export default {
  namespaced: true,
  state: {
    inProgress: false,
    subscriberData: null,
    lastUpdate: new Date(0)
  },
  mutations: {
    setSubscriberData(state:any, newSubscriberData: any) {
      state.lastUpdate = Date.now();
      state.errorMessage = null;
      state.subscriberData = newSubscriberData;
    },
    setInProgress(state: any, newValue: boolean) {
      state.inProgress = newValue;
    },
    removeSubscriberData(state: any) {
      state.subscriberData = null;
    }
  },
  getters: {
    inProgress(state: any) {
      return state.inProgress;
    },
    subscriberData(state: any) {
      return state.subscriberData;
    },
  },
  actions: {
    refreshSubscriberData(context: any, axios: any) {

      if (context.getters.status && (context.getters.lastUpdate + SUBSCRIBER_DATA_TIMEOUT > Date.now())) {
        //there is no need to refresh profile data
        return;
      } else {
        // we have outdated data, remove old one so we do not show it while loading new data
        context.commit("removeSubscriberData");
      }

      context.commit("setInProgress", true);
      axios.get('api/user/dreitvkarte/info')
        .then(
          response => {
            if (response && response.data && response.data.responseCode === RESPONSE_CODE_OK) {
              context.commit("setSubscriberData", response.data);
            } else {
              context.rootState.errorMessage = i18n.t("MANAGE.SUBSCRIBER_DATA.ERROR");
              context.rootState.setErrorMessageCalled++;
            }
          }
        ).catch(
        () => {
          context.rootState.errorMessage = i18n.t("MANAGE.SUBSCRIBER_DATA.ERROR");
          context.rootState.setErrorMessageCalled++;
        }
      ).finally(
        () => {
          context.commit("setInProgress", false);
        }
      )
    }
  }
}
